import { Substep, SUBSTEPS_IN_ORDER, SUBSTEPS_IN_ORDER_WITH_COMPLETE } from "../flow/types";
import type { DeclarativeIncomeSource } from "../flow/types";

export const isDeclarativeMonthlyIncomSourceValid = (
  data: DeclarativeIncomeSource[] | undefined | null
) => {
  if (!data) return false;
  if (data.length === 0) return false;
  return true;
};

export const getPreviousSubstep = (
  block: string,
  substepsOfMissingfields: Substep[],
  substep: Substep | null
) => {
  if (!substep) return null;
  if (substep === "person") return null;
  if (block !== "required_field") {
    return SUBSTEPS_IN_ORDER[SUBSTEPS_IN_ORDER.indexOf(substep) - 1] ?? null;
  }

  //for "required_field" flow, we filter out substeps that don't have required missing field for lv2
  const filteredSubsteps = SUBSTEPS_IN_ORDER.filter((substep) =>
    substepsOfMissingfields.includes(substep)
  );
  if (filteredSubsteps.length <= 1) return null;
  const indexSubstep = filteredSubsteps.indexOf(substep);
  if (indexSubstep === 0) return null;
  return filteredSubsteps[indexSubstep - 1] ?? null;
};

export const getNextSubstep = (
  block: string,
  substepsOfMissingfields: Substep[],
  substep: Substep | null
) => {
  if (!substep) return null;
  if (substep === "source_income") return null;
  if (block !== "required_field")
    return SUBSTEPS_IN_ORDER[SUBSTEPS_IN_ORDER.indexOf(substep) + 1] ?? null;

  //for "required_field" flow, we filter out substeps that don't have required missing field for lv2
  const filteredSubsteps = SUBSTEPS_IN_ORDER.filter((substep) =>
    substepsOfMissingfields.includes(substep)
  );
  if (filteredSubsteps.length <= 1) return null;
  const indexSubstep = filteredSubsteps.indexOf(substep);

  if (indexSubstep === filteredSubsteps.length) return null;
  return filteredSubsteps[indexSubstep + 1] ?? null;
};

export const getStepMap = () => {
  const stepMap: Record<string, string | null> = {};
  SUBSTEPS_IN_ORDER_WITH_COMPLETE.forEach(
    (substep, index) =>
      (stepMap[substep] = SUBSTEPS_IN_ORDER_WITH_COMPLETE[index + 1]
        ? SUBSTEPS_IN_ORDER_WITH_COMPLETE[index + 1]
        : null)
  );
  return stepMap;
};
